export const draftEntityTransformer = (entity: { type: string; data: any }, content: string) => {
  switch (entity.type) {
    case 'LINK':
      return `<a href="${entity.data.url}" target="${entity.data.targetOption}">${content}</a>`;
  }
};
